import { bindPage } from '../modules/page_lifecycle.js';

bindPage(() => {
  const pending = document.querySelector('.download-request[data-status="pending"]');
  if (!pending) return;

  const statusJsonUrl = `${window.location}.json`;
  const frequency = 5000;

  const interval = window.setInterval(async () => {
    try {
      const response = await fetch(statusJsonUrl, { credentials: 'same-origin' });
      if (!response.ok) return;

      const data = await response.json();
      if (data.status === 'complete' || data.status === 'error') {
        window.clearInterval(interval);
        window.location.reload();
      }
    } catch {
      // Ignore transient poll errors; next interval retries.
    }
  }, frequency);

  return () => window.clearInterval(interval);
});
